import React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Button, Tooltip } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import { useUser } from './UserContext';

const CustomAppBar = () => {
  const { user } = useUser(); // Use user from the context
  const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error("Logout Error:", error);
    }
  };

  const isDashboard = location.pathname === '/dashboard';
  const isPositions = location.pathname === '/positions';
  const isSignal = location.pathname === '/signal';

  return (
    <AppBar position="static">
      <Toolbar>
        <IconButton edge="start" color="inherit" aria-label="menu">
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Zatamap
        </Typography>
        {!isDashboard && (
          <Button color="inherit" onClick={() => navigate('/dashboard')}>Dashboard</Button>
        )}
        {!isPositions && (
          <Button color="inherit" onClick={() => navigate('/positions')}>Positions</Button>
        )}
        {!isSignal && (
          <Button color="inherit" onClick={() => navigate('/signal')}>Signal</Button>
        )}
        {user?.email ? (
        <Tooltip title={user.email}>
          <IconButton color="inherit">
            <AccountCircleIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Typography variant="body1" color="inherit">User not logged in</Typography>
      )}
        <Button color="inherit" onClick={handleLogout}>Logout</Button>
      </Toolbar>
    </AppBar>
  );
};

export default CustomAppBar;
